import React from 'react';
import { PROGRAM_TYPES } from '../utils/programType';

// Three-way Program Type choice (v2.0 US-2.3 / US-2.4). Radio semantics,
// nothing preselected at signup.
const ProgramTypePicker = ({ value, onChange, compact = false }) => (
  <div role="radiogroup" aria-label="Program type" style={{ display: 'grid', gridTemplateColumns: compact ? '1fr' : 'repeat(auto-fit, minmax(160px, 1fr))', gap: '8px' }}>
    {PROGRAM_TYPES.map((t) => {
      const selected = value === t.value;
      return (
        <button
          type="button"
          key={t.value}
          role="radio"
          aria-checked={selected}
          onClick={() => onChange(t.value)}
          style={{
            textAlign: 'left', cursor: 'pointer', borderRadius: '10px', padding: '10px 12px',
            border: selected ? '2px solid #F05A14' : '1px solid rgba(0,0,0,0.12)',
            background: selected ? '#FFF4E8' : '#fff',
          }}
        >
          <div style={{ fontSize: '13.5px', fontWeight: 700, color: '#0D1117' }}>{t.label}</div>
          <div style={{ fontSize: '12px', color: '#5A6070', marginTop: '2px' }}>{t.short}</div>
          {!compact && <div style={{ fontSize: '11.5px', color: '#9AA0B0', marginTop: '4px' }}>{t.detail}</div>}
        </button>
      );
    })}
  </div>
);

export default ProgramTypePicker;
